import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { Grid, useMediaQuery, Typography, useTheme } from "@mui/material";
import { closeModal } from "../../store/reducers/modalConductor";
import ModalWrapper from "./ModalComponents/ModalWrapper";
import ModalActions from "./ModalComponents/ModalActions";
import ModalHeader from "./ModalComponents/ModalHeader";

const GeneralModal = (props) => {
  const { icon, title, content, actions, show, onClose, header, paperClass } =
    props;
  const dispatch = useDispatch();
  const theme = useTheme();
  const isXsMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    dispatch(closeModal());
  };

  const classes = {
    content: {
      marginBottom: "24px",
      padding: "24px 24px 0px 24px",
      textAlign: "center",
      [theme.breakpoints.down("xs")]: {
        height: "100%",
      },
      overflowY: "scroll",
      "scrollbar-width": "thin",
      "scrollbar-color": theme.branding.gray[400],
      "&::-webkit-scrollbar": {
        width: 8,
      },
      "&::-webkit-scrollbar-thumb": {
        background: theme.branding.gray[600],
        "-webkit-border-radius": "12px",
      },
      "&::-webkit-scrollbar-track": {
        backgroundColor: theme.branding.gray[0],
      },
      "&::-webkit-scrollbar-track-piece:start": {
        background: "transparent",
      },
      "&-webkit-scrollbar-track-piece:end": {
        background: "transparent",
      },
    },
    paperClass: {
      borderRadius: 16,
      [theme.breakpoints.up("sm")]: {
        height: 624,
        width: 504,
      },
    },
  };

  return (
    <ModalWrapper
      paperClass={`${!isXsMobile ? classes.paperClass : ""} ${paperClass ? paperClass : ""}`}
      fullScreen={isXsMobile}
      show={show}
      onClose={handleClose}
    >
      <ModalHeader title={header} handleClose={handleClose} />
      {icon && (
        <Grid container justify="center" sx={{ fontSize: 63 }}>
          {icon}
        </Grid>
      )}
      {title && (
        <Grid
          container
          justify="center"
          sx={{
            marginBottom: 8,
            padding: `0 24px`,
            textAlign: "center",
          }}
        >
          {typeof title === "string" ? (
            <Typography variant="h3">{title}</Typography>
          ) : (
            title
          )}
        </Grid>
      )}
      {content && (
        <Grid container justify="center" sx={classes.content}>
          {typeof content === "string" ? (
            <Typography variant="body1">{content}</Typography>
          ) : (
            content
          )}
        </Grid>
      )}
      {actions && (
        <ModalActions>
          {actions.map((action, index) => (
            <Fragment key={`action${index}`}>{action}</Fragment>
          ))}
        </ModalActions>
      )}
    </ModalWrapper>
  );
};

export default GeneralModal;
